export default __webpack_public_path__ + "static/media/carousel_2.85a4ab7f.jpg";